import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getToken } from "../../helpers";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

export const fetchOrders = createAsyncThunk(
  "order/fetchOrders",
  async (_, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.get(`/orders/owner`);

      if (!response.data) {
        console.error("Нет данных в ответе");
        return rejectWithValue("Нет данных");
      }

      return response.data;
    } catch (error) {
      console.error("Ошибка при запросе:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "order/updateStatus",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const token = await getToken();

      if (!token) {
        console.error("Токен не найден");
        return rejectWithValue("Токен не найден");
      }

      const axiosInstance = axios.create({
        baseURL: API_URL,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const response = await axiosInstance.patch(`/orders/owner`, {
        id,
        status,
      });

      return response.data;
    } catch (error) {
      console.error("Ошибка при обновлении статуса:", error);
      return rejectWithValue(error.response?.data || "Ошибка сервера");
    }
  }
);

export const orderSlice = createSlice({
  name: "order",
  initialState: {
    orders: [],
    activeOrder: null,
    loading: false,
    error: null,
  },
  reducers: {
    setActiveOrder: (state, action) => {
      state.activeOrder = action.payload;
    },
    removeActiveOrder: (state) => {
      state.activeOrder = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateOrderStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.loading = false;

        // Обновим заказ в списке orders
        state.orders = state.orders.map((order) =>
          order.id === action.payload.id ? action.payload : order
        );

        // Обновим activeOrder, если он открыт
        if (state.activeOrder?.id === action.payload.id) {
          state.activeOrder = action.payload;
        }
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setActiveOrder, removeActiveOrder } = orderSlice.actions;

export default orderSlice.reducer;
